import { render, staticRenderFns } from "./PartsContainerStyle.vue?vue&type=template&id=35e11bc4&scoped=true&"
import script from "./PartsContainerStyle.vue?vue&type=script&lang=js&"
export * from "./PartsContainerStyle.vue?vue&type=script&lang=js&"
import style0 from "./PartsContainerStyle.vue?vue&type=style&index=0&id=35e11bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e11bc4",
  null
  
)

export default component.exports